// extracted by mini-css-extract-plugin
module.exports = {"bed":"bed_option_bed__x_za_","roomTitle":"bed_option_roomTitle__2httc","bedIcon":"bed_option_bedIcon__orG6S"};